import "assets/vendors/flag/sprite-flags-24x24.css";
import "assets/vendors/gaxon/styles.css";
import "react-notifications/lib/notifications.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "@/assets/vendors/noir-pro/styles.css"
